<template>
  <div :style="$cmsStyles('c_5d0afaffa1c8')" class="media-container">
    <tools-bar ref="toolsBar"></tools-bar>
    <div class="media-content">
      <div class="service-wrapper">
        <div v-show="$cms('c_5d0afaffa1c8', 'f_0001', true)" class="banner-wrapper">
          <h1 class="title">{{ $cms('c_5d0afaffa1c8', 'f_0002', "品牌 探索健康生活") }}</h1>
          <div class="desc">
            {{ $cms('c_5d0afaffa1c8', 'f_0003', "魔筷旗下品牌生态全景") }}
          </div>
          <div class="actions">
            <div class="btn-common btn-white" @click="onJoinClick(3)">{{ $cms('c_5d0afaffa1c8', 'f_0004', "主播合作") }}</div>
            <div class="btn-common" @click="onJoinClick(4)">{{ $cms('c_5d0afaffa1c8', 'f_0005', "渠道合作") }}</div>
          </div>
        </div>
        <div class="content-wrapper">
          <div v-show="$cms('c_5d0afaffa1c8', 'f_0006', true)" class="box-1">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_5d0afaffa1c8', 'f_0007', "品牌优势与理念") }}</h2>
              <div class="box-header-en-title">{{ $cms('c_5d0afaffa1c8', 'f_0008', "Advantage and Concept") }}</div>
              <div class="box-header-desc">{{ $cms('c_5d0afaffa1c8', 'f_0009', "研发驱动、差异创新、产销一体、持续升级 、品质保障、价格公道、客户信赖、渠道健康") }}</div>
            </div>
            <div class="box-content">
              <div class="item" v-for="item in advantageList" :key="item.title">
                <img class="icon" :src="item.icon" loading="lazy" :alt="item.title">
                <div class="item-title">{{ item.title }}</div>
                <ul>
                  <li v-for="listItem in item.list" :key="listItem">{{ listItem }}</li>
                </ul>
              </div>
            </div>
          </div>
          <div v-show="$cms('c_5d0afaffa1c8', 'f_0010', true)" class="box-2">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_5d0afaffa1c8', 'f_0011', "品牌生态矩阵") }}</h2>
              <div class="box-header-en-title">{{ $cms('c_5d0afaffa1c8', 'f_0012', "Ecological Matrix") }}</div>
              <div class="box-header-desc">{{ $cms('c_5d0afaffa1c8', 'f_0013', "覆盖家庭健康生活全场景") }}</div>
            </div>
            <div class="box-content">
              <div class="band-btns">
                <div class="btn" v-for="btn in brandBtns" :key="btn">{{ btn }}</div>
              </div>
              <div class="band-group-list">
                <div class="group-item" v-for="item in brandGroupList" :key="item.type">
                  <div class="group-title">{{ item.type }}</div>
                  <div class="group-item-list">
                    <div class="item" v-for="listItem in item.list" :key="listItem.name" :class="{ 'has-href': listItem.href }" @click="onBrandItemClick(listItem)">
                      <div class="item-img">
                        <img :src="listItem.img" loading="lazy" :alt="listItem.name">
                      </div>
                      <div class="item-info">
                        <div class="item-name">{{ listItem.name }}</div>
                        <div class="item-desc">{{ listItem.desc }}</div>
                      </div>
                      <div class="view-detail">{{ $cms('c_5d0afaffa1c8', 'f_0014', "查看品牌") }}<span class="arrow"></span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="$cms('c_5d0afaffa1c8', 'f_0015', true)" class="box-3">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_5d0afaffa1c8', 'f_0016', "品牌销售渠道") }}</h2>
              <div class="box-header-en-title">{{ $cms('c_5d0afaffa1c8', 'f_0017', "Distribution Channel") }}</div>
              <div class="box-header-desc">{{ $cms('c_5d0afaffa1c8', 'f_0018', "线上线下双渠道布局 实现全域触达") }}</div>
            </div>
            <div class="box-content">
              <div class="main-title">{{ $cms('c_5d0afaffa1c8', 'f_0019', "线上渠道") }}</div>
              <div class="main-desc">{{ $cms('c_5d0afaffa1c8', 'f_0020', "自营品牌累计触达数百万主播，覆盖快手、抖音、视频号等多个平台") }}</div>
              <div class="celebrity-swiper-box">
                <div
                  class="swiper"
                  @mouseenter="onSwiperEnter"
                  @mouseleave="onSwiperLeave"
                >
                  <div class="swiper-arrow prev"></div>
                  <div class="swiper-arrow next"></div>
                  <swiper ref="swiper" :options="lecturerSwiperOption">
                    <swiper-slide
                      v-for="(item, index) in lecturerSwiperData"
                      :key="index"
                    >
                      <div class="card-item">
                        <div class="mask"></div>
                        <img :src="item.img" :alt="item.name" class="main" />
                        <div class="desc-box">
                          <div class="name">
                            <!-- <img :src="item.platformIcon" alt="" class="platform-icon"> -->
                            {{ item.name }}
                          </div>
                          <!-- <div class="desc">{{ item.desc }}</div> -->
                        </div>
                      </div>
                    </swiper-slide>
                  </swiper>
                </div>
              </div>
            </div>
          </div>
          <div v-show="$cms('c_5d0afaffa1c8', 'f_0021', true)" class="box-4">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_5d0afaffa1c8', 'f_0022', "线下渠道") }}</h2>
              <div class="box-header-desc">{{ $cms('c_5d0afaffa1c8', 'f_0023', "进驻全国6大区，50000+线下门店入驻，领衔商超新零售") }}</div>
            </div>
            <div class="box-content">
              <div class="channel-item" v-for="(item, index) in channelList" :key="index">
                <img class="channel-item-img" :src="item.img" loading="lazy" :alt="item.name">
                <div class="channel-item-name">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <BrandCooperationBox />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToolsBar from '@/components/ToolsBar.vue'
import BrandCooperationBox from '@/components/brand/BrandCooperationBox.vue'

export default {
  components: {
    ToolsBar,
    BrandCooperationBox,
  },
  head() { return this.$cmsHead('c_5d0afaffa1c8', {
    title: '旗下品牌-探索健康生活|合味芳|大嘴鳄|露小白|百谜|魔筷科技',
    meta: [
      {
        name: 'Keywords',
        content:
          '旗下品牌,健康生活,合味芳,大嘴鳄,露小白,百谜,品牌生态,家庭健康,品牌矩阵,快手,抖音,视频号,小红书,魔筷科技',
      },
      {
        name: 'Description',
        content:
          '魔筷科技旗下品牌生态全景，探索健康生活。拥有合味芳、大嘴鳄、露小白、百谜等知名品牌，覆盖家庭健康生活全场景，研发驱动、差异创新、产销一体、品质保障，为消费者提供优质的健康生活产品。',
      },
    ],
  }); },
  computed: {
    swiper() {
      return this.$refs.swiper.$swiper;
    },
  },
  data() {
    return {
      lecturerSwiperOption: {
        slidesPerView: 5,
        spaceBetween: "1%",
        // observer: true,
        // observeParents: true,
        navigation: {
          nextEl: ".swiper-arrow.next",
          prevEl: ".swiper-arrow.prev",
        },
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        loop: true,
      },
      advantageList: this.$cms('c_5d0afaffa1c8', 'f_0024', [{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804192615930000215.17543067757975059.png","title":"研发溯源力","list":["从“看见需求”到“科学配方”","成立魔筷研究院，配备专业研发团队，锁定家庭生活中的健康需求，全程参与研发"]},{"title":"自主产业链","icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804192615930000596.17543067757947963.png","list":["研发→工厂→云仓→销售→售后无缝衔接","拒绝代工断层风险，六大环节100%自主掌控。自有工厂+智能云仓协同作战，保障产品品质"]},{"title":"品控生命力","icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804192615930000274.17543067757969031.png","list":["用科学质检滋养信任","从原料到成品，质检工序层层把关，我们用科技与匠心筑起品控防线；我们像守护珍宝般打磨每一份产品，不将就每一处细节，严苛品控，是我们对品质的偏执，更是对用户的尊重，只为不负你对我们的信任。"]}]),
      brandBtns: this.$cms('c_5d0afaffa1c8', 'f_0025', ["全部品牌","食品生鲜","家庭清洁","养生健康"]),
      brandGroupList: this.$cms('c_5d0afaffa1c8', 'f_0026', [{"type":"食品生鲜","list":[{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250911164601140000802.17575803609761578.png","name":"合味芳","desc":"地方特色品质速食","href":"/ourbrands/heweifang"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804175609470000937.17543013691806411.png","name":"大嘴鳄","desc":"打造新风味家庭方便小吃","href":"/ourbrands/dazuie"}]},{"type":"家庭清洁","list":[{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250911164601140000201.17575803609781679.png","name":"露小白","desc":"专业去油品牌","href":"/ourbrands/luxiaobai"},{"img":"https://mk-crm-cdn.mockuai.com/home/1788855187869612250.png","name":"蜂可立克","desc":"铸就口腔消费新锐品牌"}]},{"type":"养生健康","list":[{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20260108161230080000855.17678599494943673.png","name":"DiaryLuck 德瑞可","desc":"美国精准营养健康专家","href":"/ourbrands/diaryluck"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250911164601140000460.17575803609791059.png","name":"念都堂","desc":"专注东方御养的新式养生健康品牌","href":"/ourbrands/niandutang"}]}]),
      lecturerSwiperData: this.$cms('c_5d0afaffa1c8', 'f_0027', [{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250819105819210000770.17555722967489819.jpg","name":"芈姐","desc":"合作初首月销售额五万，进入魔筷工作室深度合作后达成开播半小时100w"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250819105819210000820.17555722967492941.jpg","name":"瑜大公子","desc":"合作初首月销售额五万，进入魔筷工作室深度合作后达成开播半小时100w"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250819105819210000565.17555722967583945.jpg","name":"大鸭梨","desc":"合作初首月销售额五万，进入魔筷工作室深度合作后达成开播半小时100w"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250819105819210000749.17555722967532734.jpg","name":"茉莉妈妈","desc":"合作初首月销售额五万，进入魔筷工作室深度合作后达成开播半小时100w"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250819105819210000544.17555722967467905.jpg","name":"董先生","desc":"合作初首月销售额五万，进入魔筷工作室深度合作后达成开播半小时100w"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250819105819210000450.17555722967553680.jpg","name":"五五","desc":"合作初首月销售额五万，进入魔筷工作室深度合作后达成开播半小时100w"}]),

      channelList: this.$cms('c_5d0afaffa1c8', 'f_0028', [{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813155708660000820.17550718283572361.png","name":"大润发"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813155708660000631.17550718283587394.png","name":"华联超市"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813155708660000871.17550718283603130.png","name":"新天地"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813155708660000206.17550718283566105.png","name":"欧亚集团"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813155708660000593.17550718283592184.png","name":"家家悦"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813155708670000705.17550718283553568.png","name":"美宜佳"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813155708660000516.17550718283589901.png","name":"永辉超市"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813155708670000600.17550718283553205.png","name":"世纪联华"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813155708660000224.17550718283592502.png","name":"朴朴"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813155708660000630.17550718283533879.png","name":"叮咚买菜"}]),
    }
  },
  methods: {
    onSwiperEnter() {
      this.swiper.autoplay.stop();
    },
    onSwiperLeave() {
      this.swiper.autoplay.start();
    },
    onBrandItemClick(item) {
      const href = typeof item.href === 'string' ? item.href.trim() : '';
      if (href) window.open(href, '_blank', 'noopener,noreferrer');
    },
    onJoinClick(type) {
      this.$router.push(`/apply-join?type=${type}`)
    },
  },
}
</script>

<style lang="less" scoped>
@import "../style/common.less";

.media-content {
  padding-top: 90px;
}

.service-wrapper {
  .banner-wrapper {
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .pxToVw(height, 680);
    background-color: #00092a;
    background-image: var(--cms-c_5d0afaffa1c8-f_0029, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731165507990000316.17539521078272214.png?x-oss-process=image/quality,Q_90"));
    background-size: cover;
    background-repeat: no-repeat;
    h1.title {
      .pxToVw(margin-bottom, 13);
      line-height: 1.4;
      .pxToVw(font-size, 60);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
    }
    .desc {
      .pxToVw(line-height, 33);
      .pxToVw(font-size, 24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
    .actions {
      display: flex;
      align-items: center;
      .pxToVw(margin-top, 77);
    }
  }
  .content-wrapper {
    .box-header {
      .pxToVw(padding-top, 80);
      color: #333333;
      &-title {
        margin: 0 auto 8 * @unitVw;
        .pxToVw(margin-bottom, 28);
        text-align: center;
        .pxToVw(line-height, 50);
        .pxToVw(font-size, 36);
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          .pxToVw(top, 64);
          left: 50%;
          .pxToVw(width, 160);
          height: 1px;
          background: #d8d8d8;
          transform: translateX(-50%);
        }
      }
      &-en-title {
        font-weight: 500;
        .pxToVw(font-size, 18);
        .pxToVw(line-height, 26);
        text-align: center;
        .pxToVw(margin-bottom, 26);
      }
      &-desc {
        text-align: center;
        .pxToVw(line-height, 25);
        .pxToVw(font-size, 18);
        font-weight: 300;
        color: #666;
      }
    }
    .box-1 {
      .pxToVw(height, 812);
      background-image: var(--cms-c_5d0afaffa1c8-f_0030, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731171108670000660.17539530684145417.jpg"));
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .box-content {
        position: relative;
        box-sizing: border-box;
        .pxToVw(margin-top, 97);
        .pxToVw(padding-left, 240);
        .pxToVw(padding-right, 240);
        .pxToVw(padding-bottom, 80);
        display: flex;
        .pxToVw(gap, 60);
        .item {
          flex: 1;
          .pxToVw(border-radius, 20);
          .pxToVw(height, 300);
          .pxToVw(padding-right, 30);
          .pxToVw(padding-left, 30);
          .pxToVw(padding-top, 100);
          background: #FFFFFF;
          position: relative;
          .icon {
            position: absolute;
            display: block;
            .pxToVw(width, 80);
            .pxToVw(top, -13);
            .pxToVw(right, 20);
          }
          .item-title {
            .pxToVw(font-size, 30);
            font-weight: 600;
            color: #333333;
            .pxToVw(line-height, 36);
          }
          li {
            .pxToVw(font-size, 18);
            .pxToVw(padding-top, 30);
            font-weight: 300;
            color: #666;
            .pxToVw(line-height, 30);
          }
        }
      }
    }

    .box-2 {
      .band-btns {
        display: flex;
        justify-content: center;
        .pxToVw(gap, 40);
        .pxToVw(padding-top, 60);
        .pxToVw(padding-bottom, 60);
        .btn {
          .pxToVw(width, 210);
          .pxToVw(height, 48);
          .pxToVw(border-radius, 30);
          .pxToVw(font-size, 18);
          .pxToVw(line-height, 25);
          box-sizing: border-box;
          font-weight: 400;
          color: #333333;
          border: 1px solid #999999;
          display: flex;
          align-items: center;
          justify-content: center;

          &:first-child {
            background: linear-gradient( 90deg, #FF6600 0%, #FC4440 100%);
            border: none;
            color: #fff;
          }
        }
      }

      .band-group-list {
        display: flex;
        flex-wrap: wrap;
        .pxToVw(width, 1440);
        margin: 0 auto;
        .pxToVw(gap, 30);
        .group-title {
          font-weight: 600;
          .pxToVw(font-size, 30);
          .pxToVw(line-height, 42);
          .pxToVw(margin-bottom, 30);
          color: #333333;
        }
        .group-item {
          width: 100%;
        }
        .group-item-list {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .item {
            display: flex;
            width: 50%;
            box-sizing: border-box;
            .pxToVw(padding-top, 30);
            .pxToVw(padding-bottom, 30);
            .pxToVw(padding-left, 40);
            background: linear-gradient( 180deg, #FCFCFC 0%, #F8F8F8 100%);
            position: relative;
            .view-detail {
              display: none;
            }
            &.has-href {
              cursor: pointer;
              &:hover {
                background: rgba(255,102,0,0.1);

                .view-detail {
                  position: absolute;
                  color: #FF6600;
                  display: flex;
                  align-items: center;
                  .pxToVw(right, 60);
                  top: 50%;
                  transform: translateY(-50%);
                  .pxToVw(font-size, 18);
                  .arrow {
                    margin-left: 3px;
                    display: block;
                    // 三角形
                    width: 0;
                    height: 0;
                    border-top: 4px solid transparent;
                    border-bottom: 4px solid transparent;
                    border-left: 4px solid #FF6600;
                    border-right: 4px solid transparent;
                  }
                }
              }
            }
            
            .item-img {
              .pxToVw(width, 180);
              .pxToVw(height, 180);
              .pxToVw(margin-right, 40);
              border-radius: 50%;
              background: #FFFFFF;
              // border: 1px solid #CCCCCC;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                display: block;
                .pxToVw(width, 180);
                .pxToVw(height, 180);
              }
            }
            .item-name {
              font-weight: 600;
              .pxToVw(font-size, 24);
              .pxToVw(line-height, 33);
              .pxToVw(margin-bottom, 36);
              .pxToVw(margin-top, 36);
              color: #333333;
            }
            .item-desc {
              font-weight: 300;
              .pxToVw(font-size, 18);
              .pxToVw(line-height, 25);
              color: #666666;
            }
          }
        }
      }
    }

    .box-3 {
      .box-content {
        .pxToVw(margin-top, 60);
        .pxToVw(height, 660);
        .pxToVw(margin-bottom, 424);
        background-image: var(--cms-c_5d0afaffa1c8-f_0031, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804163240760000417.17542963605751395.jpg?x-oss-process=image/quality,Q_90"));
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        .main-title {
          font-weight: 600;
          .pxToVw(font-size, 36);
          .pxToVw(line-height, 50);
          color: #FF6600;
          .pxToVw(margin-bottom, 20);
        }
        .main-desc {
          font-weight: 400;
          .pxToVw(font-size, 24);
          .pxToVw(line-height, 33);
          color: #FFFFFF;
        }

        .celebrity-swiper-box {
          position: absolute;
          .pxToVw(top, 350);
          left: 0;
          right: 0;
          bottom: 0;
          .pxToVw(width, 1440);
          margin: 0 auto;
          .pxToVw(padding-top, 80);
          .pxToVw(padding-bottom, 80);
          .swiper {
            position: relative;
            /deep/ .swiper-wrapper {
              .pxToVw(height, 562);
            }
            .swiper-arrow {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              width: 2.2916666666666665vw;
              height: 2.2916666666666665vw;
              background-size: cover;
              background-repeat: no-repeat;
              cursor: pointer;
              &.prev {
                left: -2.2916666666666665vw;
                background-image: var(--cms-c_5d0afaffa1c8-f_0032, url("https://mktv-in-cdn.mockuai.com/16252291642899934.png"));
              }
              &.next {
                right: -2.2916666666666665vw;
                background-image: var(--cms-c_5d0afaffa1c8-f_0033, url("https://mktv-in-cdn.mockuai.com/16252259933873886.png"));
              }
            }
            .card-item {
              box-sizing: border-box;
              position: relative;
              .pxToVw(width, 272);
              .pxToVw(height, 508);
              .pxToVw(border-radius, 16);
              overflow: hidden;
              cursor: auto;
              .mask {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                .pxToVw(border-radius, 16);
                background: linear-gradient(
                  180deg,
                  rgba(0, 9, 42, 0) 0%,
                  rgba(0, 9, 42, 0.77) 100%
                );
              }
              .main {
                display: block;
                .pxToVw(width, 272);
              }
              .desc-box {
                position: absolute;
                .pxToVw(bottom, 20);
                left: 0;
                .pxToVw(padding-left, 18);
                .pxToVw(padding-right, 18);
                color: #fff;
                text-align: center;
                right: 0;
                .name {
                  .pxToVw(margin-bottom, 5);
                  .pxToVw(font-size, 20);
                  font-weight: 500;
                  color: #ffffff;
                  .pxToVw(line-height, 28);
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  .platform-icon {
                    .pxToVw(width, 20);
                    .pxToVw(height, 20);
                    .pxToVw(margin-right, 4);
                  }
                }
                .desc {
                  .pxToVw(font-size, 14);
                  .pxToVw(line-height, 20);
                  font-weight: 300;
                  color: #ffffff;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
                  opacity: 0.8;
                }
              }
            }
          }
        }
      }
      
    }

    .box-4 {
      .pxToVw(height, 943);
      background-image: var(--cms-c_5d0afaffa1c8-f_0034, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804164912730000362.17542973524741220.jpg?x-oss-process=image/quality,Q_80"));
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .box-header-title {
        color: #FF6600;
      }
      .box-header-desc {
        color: #FFF;
      }

      .box-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .pxToVw(width, 1440);
        margin: 0 auto;
        .pxToVw(gap, 20);
        .pxToVw(padding-top, 60);
        .channel-item {
          .pxToVw(width, 272);
          .pxToVw(height, 300);
          background: rgba(255, 255, 255, 0.2);
          box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.1);
          .pxToVw(border-radius, 16);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          &-img {
            .pxToVw(width, 180);
            .pxToVw(height, 180);
            background: #FFFFFF;
            // border: 1px solid #CCCCCC;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
          }
          &-name {
            .pxToVw(margin-top, 26);
            font-weight: 500;
            .pxToVw(font-size, 24);
            .pxToVw(line-height, 34);
            color: #FFFFFF;
          }
        }
      }
    }
  }
}
</style>
